import axios from './axios';

export const getBusesByCarrierId = carrierId =>
  axios.get(`/transportation/carriers/${carrierId}/buses`);

export const createBus = (carrierId, bus) =>
  axios.post('/transportation/buses', {
    busCompanyId: carrierId,
    ...bus,
  });

export const updateBus = (carrierId, busId, bus) =>
  axios.put(`/transportation/buses/${busId}`, {
    busCompanyId: carrierId,
    ...bus,
  });

export const removeBus = busId => axios.delete(`/transportation/buses/${busId}`);

export const getBusLocations = busIds =>
  axios.post('/transportation/buses/location', {
    busIds,
  });

export const getAgendaBusLocation = busId => axios.get(`/transportation/buses/${busId}/location`);
